/* ============================================================
   CULT UI · JS · LOST PROJECT
   Subir a: assets/cult-ui.js
   Cargar en theme.liquid (antes de </body>):
   <script src="{{ 'cult-ui.js' | asset_url }}" defer></script>
   ============================================================ */
(function() {
  'use strict';

  function initTabs(scope) {
    scope = scope || document;
    const tabContainers = scope.querySelectorAll('.cult-tabs');

    tabContainers.forEach(container => {
      const nav = container.querySelector('.cult-tabs__nav');
      const indicator = container.querySelector('.cult-tabs__indicator');
      if (!nav || !indicator) return;

      const buttons = nav.querySelectorAll('button[data-tab]');
      const panels = container.querySelectorAll('.cult-tabs__panel');

      function moveIndicator(btn) {
        if (!btn) return;
        const rect = btn.getBoundingClientRect();
        const navRect = nav.getBoundingClientRect();
        indicator.style.left = (rect.left - navRect.left) + 'px';
        indicator.style.width = rect.width + 'px';
      }

      requestAnimationFrame(() => moveIndicator(nav.querySelector('button.active') || buttons[0]));

      buttons.forEach(btn => {
        btn.addEventListener('click', () => {
          buttons.forEach(b => b.classList.remove('active'));
          panels.forEach(p => p.classList.remove('active'));
          btn.classList.add('active');
          const panel = container.querySelector(`.cult-tabs__panel[data-panel="${btn.dataset.tab}"]`);
          if (panel) panel.classList.add('active');
          moveIndicator(btn);
        });
        btn.addEventListener('mouseenter', () => moveIndicator(btn));
      });

      nav.addEventListener('mouseleave', () => {
        moveIndicator(nav.querySelector('button.active') || buttons[0]);
      });

      window.addEventListener('resize', () => {
        moveIndicator(nav.querySelector('button.active') || buttons[0]);
      });
    });
  }

  function initAccentButtons(scope) {
    scope = scope || document;
    scope.querySelectorAll('.btn-cult-accent').forEach(btn => {
      if (btn.dataset.cultInit) return;
      btn.dataset.cultInit = '1';
      btn.addEventListener('mousemove', (e) => {
        const rect = btn.getBoundingClientRect();
        btn.style.setProperty('--mx', ((e.clientX - rect.left) / rect.width * 100) + '%');
        btn.style.setProperty('--my', ((e.clientY - rect.top) / rect.height * 100) + '%');
      });
    });
  }

  function initAll(scope) {
    initTabs(scope);
    initAccentButtons(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  // Re-inicializar cuando Shopify recarga secciones desde el editor
  document.addEventListener('shopify:section:load', e => initAll(e.target));
})();